/* «Сделать кружок» с итога движений (§16, §20.2: «Кружок из видео» с готовым роликом — только кадр в круг).
   Маршрут публикует сервер в result_actions экрана dance (circle_app_id); экран-приёмник проверяется так же, как у «Видео»
   (video-result-target.ts): форма кружка с полем video и политикой video_original_speech. Ролик передаётся в памяти вкладки
   (stageVideoResult), импорт на приёмнике требует нового подтверждения прав (VideoResultImport). */
import { endpoints } from '../../api';
import type { SpeechOrder } from '../../api/speech';
import { record } from '../studio/studio-content';
import { studioApi } from '../studio/studio-api';
import { stageVideoResult } from '../video/video-result-entry';

export function motionCircleAppId(resultActions: unknown) {
  const id = record(resultActions).circle_app_id;
  return Number.isSafeInteger(id) && Number(id) > 0 ? Number(id) : null;
}
export async function motionCircleTarget(resultActions: unknown, signal: AbortSignal) {
  const appId = motionCircleAppId(resultActions);
  if (!appId) throw new Error('motion_result_action_unavailable');
  const [app, form] = await Promise.all([studioApi.app(appId, signal), studioApi.form(appId, signal)]);
  const policy = record(form.constraints?.circle);
  if (
    signal.aborted ||
    app.id !== appId ||
    form.app_id !== appId ||
    !form.available ||
    !['who', 'circle'].includes(app.entry.screen) ||
    !['who', 'circle'].includes(form.screen) ||
    !form.fields.some(f => f.key === 'video' && f.upload?.kind === 'video') ||
    policy.video_original_speech !== true
  )
    throw new Error('motion_result_action_unavailable');
  const format = form.fields.find(f => f.key === 'format')?.values.includes('circle') ? 'circle' : String(policy.default_format ?? '');
  return { appId, format };
}
/** Передать готовый ролик в «Кружок из видео»: владелец, заказ и ревизия результата перечитываются с сервера. */
export async function motionToCircle(opts: {
  owner: number | undefined;
  orderId: number;
  revision: number | undefined;
  resultActions: unknown;
  signal: AbortSignal;
}) {
  const me = await endpoints.me();
  if (opts.signal.aborted) return false;
  if (!opts.owner || me.user.id !== opts.owner) throw new Error('owner_changed');
  const target = await motionCircleTarget(opts.resultActions, opts.signal);
  const order: SpeechOrder = await endpoints.speech.get(opts.orderId, opts.signal);
  const asset = order.result?.assets.find(a => a.mime === 'video/mp4');
  if (order.status !== 'done' || !order.result?.available || !asset || order.result_revision !== opts.revision) throw new Error('source_changed');
  const blob = await endpoints.speech.result(order, asset.index, opts.signal);
  if (opts.signal.aborted) return false;
  if (blob.type !== 'video/mp4') throw new Error('invalid_result');
  stageVideoResult({
    owner: me.user.id,
    orderId: opts.orderId,
    revision: order.result_revision,
    index: asset.index,
    file: new File([blob], 'video.mp4', { type: blob.type }),
    speech: 'original',
    appId: target.appId,
    format: target.format,
  });
  return true;
}
